/**
 * @description Hook utilizado para manipular as entidades ExameLocal
 * @author Diego Sabino Amorim de Araújo
 * @file useExameLocalService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const useExameLocalService = () => {
  const fetch = useFetch()

  const listarExameLocal = async (id, setExameLocal, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`exameLocal/${id}`)
      setExameLocal(response.data.exameLocal)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const editarExameLocal = async (id, dados, setExameLocal, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.put(`exameLocal/${id}`, dados)
      await listarExameLocal(id, setExameLocal, setProcessando)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarExameLocalComAnalise = async (id, tipo, setExameLocal, setProcessando) => {
    try {
      if (!id) {
        setExameLocal(undefined);
        return;
      }
      if (!!tipo && !['ACHADO_CADAVER', 'TRAFEGO', 'INCENDIO', 'ENGENHARIA_LEGAL', 'IMOVEL', 'AMBIENTAL', 'TENTATIVA_HOMICIDIO'].includes(tipo)) {
        setExameLocal(undefined);
        return;
      }
      if (setProcessando) setProcessando(true)
      const response = await fetch.getWithOptionsWithoutFeedback(`exameLocal/comAnalise/${id}`)
      if (!!response?.data?.exameLocal) setExameLocal(response.data.exameLocal)
      else setExameLocal({})
    } catch (err) {
      setExameLocal(undefined)
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return { listarExameLocal, editarExameLocal, listarExameLocalComAnalise }
}
